
import ThemeContextWrapper from "./components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "./components/BackgroundColorWrapper/BackgroundColorWrapper";
import React from "react";
import { HashRouter as Routers, Route, Switch, Redirect } from "react-router-dom";
import Login from './views/Login.js';
import AdminLayout from "./layouts/Admin.js";
import useToken from './helpers/useToken';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

export default function App() {
    const { token, setToken } = useToken();
    // console.log("token", token)
    if(!token) {
        return <Login setToken={setToken} />
    }
    return (
        <ThemeContextWrapper>
            <BackgroundColorWrapper>
                <Routers>
                    <Switch>
                        <Route path="/" render={(props) => <AdminLayout {...props} token={token} setToken={setToken} />} />
                        <Redirect from="*" to="/" />
                    </Switch>
                </Routers>
            </BackgroundColorWrapper>
        </ThemeContextWrapper>
    );
};
